import { render, staticRenderFns } from "./chonghai-carousel.vue?vue&type=template&id=644b9fd6&scoped=true"
import script from "./chonghai-carousel.vue?vue&type=script&lang=js"
export * from "./chonghai-carousel.vue?vue&type=script&lang=js"
import style0 from "./chonghai-carousel.vue?vue&type=style&index=0&id=644b9fd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b9fd6",
  null
  
)

export default component.exports